<template>
	<div class="app-dialog" v-if="isVisible">
		<div class="app-dialog__main">
			<div class="app-dialog__start">
				<img src="@/assets/images/app-image.png" />
			</div>
			<div class="app-dialog__end">
				<button type="button" @click="closeDialog">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M13.0547 12L17.7891 7.28906C17.8516 7.21094 17.8984 7.13281 17.9297 7.05469C17.9766 6.96094 18 6.85938 18 6.75C18 6.54688 17.9219 6.375 17.7656 6.23438C17.625 6.07812 17.4531 6 17.25 6C17.1406 6 17.0391 6.02344 16.9453 6.07031C16.8672 6.10156 16.7891 6.14844 16.7109 6.21094L12 10.9453L7.28906 6.21094C7.21094 6.14844 7.125 6.10156 7.03125 6.07031C6.95312 6.02344 6.85938 6 6.75 6C6.54688 6 6.36719 6.07812 6.21094 6.23438C6.07031 6.375 6 6.54688 6 6.75C6 6.85938 6.01562 6.96094 6.04688 7.05469C6.09375 7.13281 6.14844 7.21094 6.21094 7.28906L10.9453 12L6.21094 16.7109C6.14844 16.7891 6.09375 16.875 6.04688 16.9688C6.01562 17.0469 6 17.1406 6 17.25C6 17.3594 6.01562 17.4609 6.04688 17.5547C6.09375 17.6328 6.14844 17.7109 6.21094 17.7891C6.28906 17.8516 6.36719 17.9062 6.44531 17.9531C6.53906 17.9844 6.64062 18 6.75 18C6.85938 18 6.95312 17.9844 7.03125 17.9531C7.125 17.9062 7.21094 17.8516 7.28906 17.7891L12 13.0547L16.7109 17.7891C16.7891 17.8516 16.8672 17.9062 16.9453 17.9531C17.0391 17.9844 17.1406 18 17.25 18C17.3594 18 17.4531 17.9844 17.5312 17.9531C17.625 17.9062 17.7109 17.8516 17.7891 17.7891C17.8516 17.7109 17.8984 17.6328 17.9297 17.5547C17.9766 17.4609 18 17.3594 18 17.25C18 17.1406 17.9766 17.0469 17.9297 16.9688C17.8984 16.875 17.8516 16.7891 17.7891 16.7109L13.0547 12Z" fill="currentColor"/>
					</svg>
				</button>
				<div class="app-dialog__content">
					<span class="app-dialog__title">Ankete na dlani</span>
					<span class="app-dialog__subtitle">Prenesite mobilno aplikacijo Episcenter klub.</span>
					<div class="app-dialog__apps">
						<a href="https://play.google.com/store/apps/details?id=si.episcenter.klub.app" target="_blank">
							<img src="@/assets/images/app-googleplay.png" />
						</a>
						<a href="https://apps.apple.com/us/app/episcenter-klub/id6479641699" target="_blank">
							<img src="@/assets/images/app-appstore.png" />
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppDialog",
	data() {
		return {
			isVisible: false
		};
	},
	methods: {
		closeDialog() {
			this.isVisible = false;
		},
		openDialog() {
			this.isVisible = true;
		}
	}
};
</script>